import React from "react";

export const initialModal = () => ({
  title: "Welcome Aboard!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title">
        Welcome to <strong>Travel Passport!</strong>
      </div>
      <div className="modal-description-contents">
        Track the countries you’ve visited by stamping your passport. Start
        typing a country name and hit “Stamp” to add its flag and unlock badges
        as you explore regions and milestones!
      </div>
      <div className="modal-description-footer">
        Ready to embark on your journey?
      </div>
    </div>
  ),
  buttonText: "Start",
  buttonType: "start",
});
